import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';

const SetLogger = ({ 
  currentSet = 1,
  totalSets = 4,
  onLogSet,
  onSkipSet,
  previousWeight = 135,
  previousReps = 10
}) => {
  const [weight, setWeight] = useState(previousWeight);
  const [reps, setReps] = useState(previousReps);

  const handleLogSet = () => {
    onLogSet({ weight, reps, setNumber: currentSet });
  };

  const quickAdjustWeight = (amount) => {
    setWeight(prev => Math.max(0, prev + amount));
  };

  const quickAdjustReps = (amount) => {
    setReps(prev => Math.max(0, prev + amount));
  };

  return (
    <div className="bg-card border border-border rounded-lg shadow-md p-4 md:p-6">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg md:text-xl font-heading font-semibold text-foreground">
          Set {currentSet} of {totalSets}
        </h3>
        <div className="flex items-center gap-2">
          <div className="flex gap-1">
            {Array.from({ length: totalSets })?.map((_, index) => (
              <div
                key={index}
                className={`
                  w-2 h-2 rounded-full transition-smooth
                  ${index < currentSet - 1 
                    ? 'bg-success' 
                    : index === currentSet - 1 
                      ? 'bg-accent' :'bg-muted'
                  }
                `}
                aria-label={`Set ${index + 1} ${index < currentSet - 1 ? 'completed' : index === currentSet - 1 ? 'current' : 'upcoming'}`}
              />
            ))}
          </div>
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
        <div>
          <label className="block text-sm font-medium text-foreground mb-2">
            Weight (lbs)
          </label>
          <div className="flex items-center gap-2">
            <Button
              variant="outline"
              size="icon"
              onClick={() => quickAdjustWeight(-5)}
              aria-label="Decrease weight by 5 lbs"
            >
              <Icon name="Minus" size={16} />
            </Button>
            <Input
              type="number"
              value={weight}
              onChange={(e) => setWeight(Number(e?.target?.value))}
              className="text-center data-text"
              min="0"
            />
            <Button
              variant="outline"
              size="icon"
              onClick={() => quickAdjustWeight(5)}
              aria-label="Increase weight by 5 lbs"
            >
              <Icon name="Plus" size={16} />
            </Button>
          </div>
        </div>

        <div>
          <label className="block text-sm font-medium text-foreground mb-2">
            Reps
          </label>
          <div className="flex items-center gap-2">
            <Button
              variant="outline"
              size="icon"
              onClick={() => quickAdjustReps(-1)}
              aria-label="Decrease reps by 1"
            >
              <Icon name="Minus" size={16} />
            </Button>
            <Input
              type="number"
              value={reps}
              onChange={(e) => setReps(Number(e?.target?.value))}
              className="text-center data-text"
              min="0"
            />
            <Button
              variant="outline"
              size="icon"
              onClick={() => quickAdjustReps(1)}
              aria-label="Increase reps by 1"
            >
              <Icon name="Plus" size={16} />
            </Button>
          </div>
        </div>
      </div>
      <div className="flex flex-col sm:flex-row gap-3">
        <Button
          variant="outline"
          onClick={onSkipSet}
          className="flex-1"
          iconName="SkipForward"
          iconPosition="left"
        >
          Skip Set
        </Button>
        <Button
          variant="default"
          onClick={handleLogSet}
          className="flex-1"
          iconName="Check"
          iconPosition="left"
        >
          Log Set
        </Button>
      </div>
      {previousWeight && previousReps && (
        <div className="mt-4 p-3 bg-muted rounded-lg">
          <p className="text-xs caption text-muted-foreground">
            Previous: {previousWeight} lbs × {previousReps} reps
          </p>
        </div>
      )}
    </div>
  );
};

export default SetLogger;